export default () => ({
  cardHeader: {
    margin: 0,
    display: 'flex',
    lineHeight: '48px',
  },
  card: {
    marginTop: 0,
    marginBottom: 30,
    display: 'flex',
    flexDirection: 'column',
  },
});
